import { render } from "./ImagesView.vue?vue&type=template&id=72a86fcc&scoped=true"
import script from "./ImagesView.vue?vue&type=script&lang=js"
export * from "./ImagesView.vue?vue&type=script&lang=js"

import "./ImagesView.vue?vue&type=style&index=0&id=72a86fcc&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a86fcc"]])

export default __exports__
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QUploader,QCard,QSpinner,QCardSection,QSelect,QBtn,QImg,QDialog,QCardActions});qInstall(script, 'directives', {ClosePopup});
